"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shade = exports.mix = exports.darken = exports.brighten = exports.alpha = void 0;
var _chromaJs = _interopRequireDefault(require("chroma-js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const darken = function (color) {
  let degree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return (0, _chromaJs.default)(color).darken(degree).hex();
};
exports.darken = darken;
const brighten = function (color) {
  let degree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return (0, _chromaJs.default)(color).brighten(degree).hex();
};
exports.brighten = brighten;
const alpha = function (color) {
  let opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return (0, _chromaJs.default)(color).alpha(opacity).css();
};
exports.alpha = alpha;
const mix = function (colorA, colorB) {
  let opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return (0, _chromaJs.default)(colorA).mix(colorB, opacity).css();
};
exports.mix = mix;
const shade = function (color) {
  let shade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  if (shade === 100) return color;
  if (shade < 100) return _chromaJs.default.mix('white', color, shade / 100, 'rgb').hex().toUpperCase();
  return _chromaJs.default.mix(color, 'black', (shade - 100) / 100, 'rgb').set('hsl.s', (0, _chromaJs.default)(color).get('hsl.s')).hex().toUpperCase();
};
exports.shade = shade;